import { render, staticRenderFns } from "./quoteList.vue?vue&type=template&id=39a62d37&scoped=true&"
import script from "./quoteList.vue?vue&type=script&lang=js&"
export * from "./quoteList.vue?vue&type=script&lang=js&"
import style0 from "./quoteList.vue?vue&type=style&index=0&id=39a62d37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a62d37",
  null
  
)

export default component.exports